// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React from 'react'
// import { KTIcon, toAbsoluteUrl } from '../../../helpers'
// import { Dropdown1 } from '../../content/dropdown/Dropdown1'
// import { useNavigate } from 'react-router-dom'

// type Props = {
//   className: string
//   linkTo?: string
//   cleanUpData?: any
// }

// const TablesWidgetSku1: React.FC<Props> = ({ className, linkTo = '', cleanUpData }) => {

//   // console.log("cleanUpData is ", cleanUpData?.customerItemQuantities)
//   const navigate = useNavigate()

//   let dataArray: any[] = []
//   if (cleanUpData) {
//     dataArray = Array.isArray(cleanUpData)
//       ? cleanUpData
//       : cleanUpData.data && Array.isArray(cleanUpData.data)
//         ? cleanUpData.data
//         : []
//   }

//   const hasData = dataArray.length > 0

//   const renderTableBody = () => {
//     if (!hasData) {
//       return (
//         <tr>
//           <td>
//             <div className='symbol symbol-50px me-2'>
//               {/* <span className='symbol-label'>
//                 <img
//                   src={toAbsoluteUrl('/media/svg/brand-logos/plurk.svg')}
//                   className='h-50 align-self-center'
//                   alt=''
//                 />
//               </span> */}
//               {Object.keys(cleanUpData?.customerItemQuantities || {})[0]}
//             </div>
//           </td>
//           <td>
//             <div>
//               {Object.keys(
//                 Object.values(cleanUpData?.customerItemQuantities || {})[0] as Record<string, unknown> || {}
//               )[0]}
//             </div>
//           </td>
//           <td className=''>
//             <div>
//               {String(
//                 Object.values(
//                   Object.values(cleanUpData?.customerItemQuantities || {})[0] as Record<string, unknown> || {}
//                 )[0] || ''
//               )}
//             </div>
//           </td>
//         </tr>
//       )
//     }

//     return dataArray.map((item: any, index: number) => (
//       <tr key={item.id || index}>
//         <td>
//           <div className='symbol symbol-50px me-2'>{item?.pickupPointName || 'N/A'}</div>
//         </td>
//         <td>
//           <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
//             {item?.customerName || 'Top Authors'}
//           </a>
//           <span className='text-dark fw-semibold d-block fs-7'>
//             {item?.source || 'Successful Fellas'}
//           </span>
//         </td>
//         <td className=''>
//           <span className='badge badge-light-danger fw-semibold me-1'>
//             {item?.orderDetails?.[0]?.categoryName || 'Angular'}
//           </span>
//           <span className='badge badge-light-info fw-semibold me-1'>
//             {item?.orderDetails?.[0]?.items?.[0]?.itemName || 'PHP'}
//           </span>
//         </td>
//         <td className=''>
//           <span className='text-dark fw-semibold'>
//             {item?.orderDetails?.[0]?.items?.[0]?.quantity || 0}
//           </span>
//         </td>
//       </tr>
//     ))
//   }

//   return (
//     <div className={`card ${className}`}>
//       <div className='card-header border-0 pt-5'>
//         <h3 className='card-title align-items-start flex-column'>
//           <span className='card-label fw-bold fs-3 mb-1'>Material inflow</span>
//           <span className='text-dark mt-1 fw-semibold fs-7'>Last 10 data</span>
//         </h3>
//         <div className='card-toolbar'>
//           <button
//             type='button'
//             onClick={() => navigate(linkTo)}
//             className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
//             data-kt-menu-trigger='click'
//             data-kt-menu-placement='bottom-end'
//             data-kt-menu-flip='top-end'
//           >
//             {/* View More */}
//           </button>
//           <Dropdown1 />
//         </div>
//       </div>
//       <div className='card-body py-3'>
//         <div className='table-responsive'>
//           <table className='table align-middle gs-0 gy-5'>
//             <thead>
//               <tr>
//                 <th className='p-0  min-w-150px'>SKU name</th>
//                 <th className='p-0 min-w-150px'>Supplier</th>
//                 {/* <th className='p-0 min-w-150px'>Material</th> */}
//                 <th className='p-0 min-w-90px'>Quantity</th>
//               </tr>
//             </thead>
//             <tbody>{renderTableBody()}</tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   )
// }

// export { TablesWidgetSku1 }



/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { useNavigate } from 'react-router-dom'

type Props = {
  className: string
  linkTo?: string
  cleanUpData?: any
}

const TablesWidgetSku1: React.FC<Props> = ({ className, linkTo = '', cleanUpData }) => {
  const navigate = useNavigate()

  const renderTableBody = () => {
    if (!cleanUpData || !cleanUpData.customerItemQuantities) {
      return (
        <tr>
          <td colSpan={3}>
            <span className='text-dark fw-semibold'>No data available</span>
          </td>
        </tr>
      );
    }

    const rows: Array<{ skuName: string; supplier: string; quantity: number }> = [];
    Object.entries(cleanUpData.customerItemQuantities).forEach(([skuName, suppliers]) => {
      Object.entries(suppliers as Record<string, number>).forEach(([supplier, quantity]) => {
        rows.push({
          skuName,
          supplier,
          quantity
        });
      });
    });

    return rows.map((row, index) => (
      <tr key={index}>
        <td>
          <div className='symbol-label'>
            {row.skuName}
          </div>
        </td>
        <td>
          <span className='text-dark fw-bold mb-1 fs-6'>
            {row.supplier}
          </span>
        </td>
        <td className=''>
          <span
            className='fw-semibold'
            style={{
              backgroundColor: '#dfffea',
              color: '#17c653',
              borderRadius: '4px',
              padding: '2px 6px'
            }}
          >
            {Number(row.quantity).toFixed(2)}
          </span>
        </td>
      </tr>
    ));
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Material inflow</span>
          {/* <span className='text-dark mt-1 fw-semibold fs-7'>Last 10 data</span> */}
        </h3>
        <div className='card-toolbar'>
          <button
            type='button'
            onClick={() => navigate(linkTo)}
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            {/* View More */}
          </button>
          <Dropdown1 />
        </div>
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <table className='table align-middle gs-0 gy-5'>
            <thead>
              <tr>
                <th className='p-0  min-w-150px'>SKU name</th>
                <th className='p-0 min-w-150px'>Supplier</th>
                <th className='p-0 min-w-90px'>Quantity</th>
              </tr>
            </thead>
            <tbody>{renderTableBody()}</tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export { TablesWidgetSku1 }